import { alpha, useTheme } from '@mui/material';
const useIncidentTileStyles = (incidentCount) => {
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    return {
        tileStyles: {
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            py: 1.5,
            px: 2,
            width: '100%',
            cursor: 'pointer',
            alignItems: 'center'
        },
        imageContainerStyles: {
            width: 46,
            height: 46,
            borderRadius: '8px',
            position: 'relative',
            overflow: 'hidden'
        },
        imageStyles: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        eyeStyles: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        tileContentContainerStyles: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            gap: 0.5,
            justifyContent: 'center'
        },
        incidentCountChipStyles: {
            fontSize: 13,
            fontWeight: 500,
            lineHeight: '18px',
            textAlign: 'center',
            height: 28,
            color: incidentCount && incidentCount > 75
                ? isLightMode
                    ? theme.palette.error.dark
                    : theme.palette.error.light
                : incidentCount && incidentCount >= 45
                    ? isLightMode
                        ? theme.palette.warning.dark
                        : theme.palette.warning.light
                    : incidentCount && incidentCount < 45
                        ? isLightMode
                            ? theme.palette.info.dark
                            : theme.palette.info.light
                        : undefined,
            background: incidentCount && incidentCount > 75
                ? alpha(theme.palette.error.main, 0.16)
                : incidentCount && incidentCount >= 45
                    ? alpha(theme.palette.warning.main, 0.16)
                    : incidentCount && incidentCount < 45
                        ? alpha(theme.palette.info.main, 0.16)
                        : undefined,
            transition: 'background-color 0.2s ease',
            '&:hover': {
                backgroundColor: incidentCount && incidentCount > 75
                    ? alpha(theme.palette.error.main, 0.08)
                    : incidentCount && incidentCount >= 45
                        ? alpha(theme.palette.warning.main, 0.08)
                        : incidentCount && incidentCount < 45
                            ? alpha(theme.palette.info.main, 0.08)
                            : alpha(theme.palette.grey[500], 0.08)
            }
        },
        alertIconStyles: {
            width: 65,
            height: 30,
            borderRadius: '100px',
            display: 'flex',
            gap: 0.5,
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.palette.common.white
        }
    };
};
export default useIncidentTileStyles;
